export default defineTemplateMeta({
  middleware: ['isn-auth']
})
